<template>
  <HorizontalStackChart
    v-bind:title="title"
    v-bind:data="data"
    v-bind:labels="labels"
    v-bind:ratio="labels.length > 10 ? true : false"
  />
</template>

<script>
import HorizontalStackChart from "@/components/management/statistics/common/HorizontalStackChart";
import { getAccessByModelChartData } from "@/api/statisticsV2";

export default {
  components: {
    HorizontalStackChart,
  },
  data() {
    return {
      title: "Access by Model",
      data: [],
      labels: [],
    };
  },
  methods: {
    async getData(startDate, endDate, tier) {
      let loader = this.$loading.show({});
      try {
        let response = await getAccessByModelChartData(startDate, endDate, tier);
        this.labels = response.data.name;
        this.data = response.data.data;
      } finally {
        loader.hide();
      }
    },
  },
};
</script>

<style></style>
